import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbWebformsService } from './mb-webforms.service'

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    MbWebformsService
  ]
})
export class MbWebformsModule {}
